import {
  ElementId,
  ElementName,
  ElementPath,
  ElementRole,
  PathSegment,
} from '../types';

export const elementPathToString = (elementPath: ElementPath): string => {
  const segments = elementPath
    .map(segment => `${segment.role}.${segment.name}`)
    .join('/');
  return `/${segments}`;
};

export const parseElementId = (elementId: ElementId): PathSegment => {
  const dotIndex = elementId.indexOf('.');
  if (dotIndex === -1 || dotIndex === 0 || dotIndex === elementId.length - 1) {
    throw new Error(`Invalid element ID: ${elementId}`);
  }

  const role = elementId.substring(0, dotIndex);
  const name = elementId.substring(dotIndex + 1);

  return {
    role: role as ElementRole,
    name: name as ElementName,
  };
};
